<template>
  <div class="event-lots">
    <div class="text-center my-9" v-if="formLoading">
      <b-spinner variant="primary" />
    </div>

    <template v-else>
      <div class="d-lg-flex align-items-center justify-content-between mb-3">
        <h2>{{ title }}</h2>
        <bp-switch v-model="isActive" label="Ativar/Desativar ingresso" />
      </div>

      <lot-form
        class="py-6"
        :lot="form"
        :parent-options="lots"
        @reset-end-date="resetEndDate"
      />

      <div
        class="d-flex flex-column flex-lg-row justify-content-between align-items-center mt-3"
      >
        <bp-button
          size="xl"
          label="Salvar"
          class="order-lg-1"
          :loading="loading"
          :disabled="!isValid || loading"
          @click="submit"
        />
        <bp-button
          color="neutral"
          variant="filled-1"
          size="xl"
          icon="fa fa-angle-left"
          label="Voltar"
          @click="$router.go(-1)"
        />
      </div>
    </template>
  </div>
</template>

<script>
import LotForm from "@/components/product/events/LotForm.vue";
import {
  clearObject,
  formFields,
  toComputerDate,
  toHumanDate
} from "@/functions/helpers";
import { mapState } from "vuex";

export default {
  components: {
    LotForm
  },
  data() {
    return {
      ...formFields(
        [
          "name",
          "code",
          "stock",
          "price",
          "type",
          "parent_id",
          "start_at",
          "end_at",
          "status",
          "product_id"
        ],
        {
          type: "by_date",
          status: "enabled",
          product_id: this.$route.params.id
        }
      ),
      loading: false,
      formLoading: false
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("events", ["lots", "lot"]),
    isValid() {
      const requiredFields = ["name", "stock", "price", "type", "end_at"];
      return (
        !requiredFields.find(f => !this.form[f]) &&
        !!(this.form.parent_id || this.form.start_at) &&
        this.form.price >= 4
      );
    },
    title() {
      if (this.$route.params.lot_code)
        return this.lot?.name || "Editar Ingresso";
      return "Novo ingresso";
    },
    isActive: {
      get() {
        return this.form.status === "enabled";
      },
      set(v) {
        this.form.status = v ? "enabled" : "canceled";
      }
    }
  },
  methods: {
    async submit() {
      this.loading = true;

      let data = clearObject({ ...this.form });
      data.start_at = toComputerDate(data.start_at);
      data.end_at = toComputerDate(data.end_at);

      const action = this.$route.params.lot_code
        ? "events/editLot"
        : "events/createLot";

      if (data.type == "by_date" && data.parent_id) {
        data.parent = null;
        data.parent_id = null;
      }

      try {
        await this.$store.dispatch(action, data);
        this.$message.success("Ingresso salvo");
        this.$router.push({
          name: "event-lots",
          params: { id: this.$route.params.id }
        });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },

    setLot() {
      this.formLoading = true;
      this.$store
        .dispatch("events/getLot", this.$route.params.lot_code)
        .then(lot => {
          lot.start_at = toHumanDate(lot.start_at);
          lot.end_at = toHumanDate(lot.end_at);
          lot.parent_id = lot.parent?.id;
          this.form = { ...this.form, ...lot };
        })
        .finally(() => (this.formLoading = false));
    },
    resetEndDate() {
      this.form.end_at = null;
    }
  },
  mounted() {
    this.$store.dispatch("events/getLots", {
      product_id: this.$route.params.id
    });

    if (this.$route.params.lot_code) {
      this.setLot();
    }
  }
};
</script>
